import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { PrivateRouteProps } from "../types/common";

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children: Children,
  requiredPermission,
  permissionKey,
  secondaryKey,
  ...rest
}) => {
  const location = useLocation();
  // return Children
  const { isAuthenticated, token, rolePermissions, user } = useSelector(
    (state: RootState) => state.auth,
  );

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (user && !user?.force_change_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" />;
  }

  if (user && user?.force_change_password && location.pathname === '/change-password') {
    return <Navigate to="/" />;
  }

  if (rolePermissions && permissionKey && requiredPermission) {
    const hasPermission = rolePermissions[permissionKey as keyof typeof rolePermissions]
      ? requiredPermission !== "is_available" &&
      rolePermissions[permissionKey as keyof typeof rolePermissions][requiredPermission]?.is_visible &&
      (secondaryKey
        ? rolePermissions[permissionKey as keyof typeof rolePermissions][requiredPermission]?.type === "All" ||
        (rolePermissions[permissionKey as keyof typeof rolePermissions][requiredPermission]?.type === "partial" &&
          Array.isArray(rolePermissions[permissionKey as keyof typeof rolePermissions][requiredPermission]?.partial) &&
          rolePermissions[permissionKey as keyof typeof rolePermissions][requiredPermission]?.partial.includes(secondaryKey))
        : true)
      : false;

    return token && hasPermission ? Children : <Navigate to="/not-found" />;
  }
  else {
    return token ? Children : <Navigate to="/unauthorized" />;
  }
};

export default PrivateRoute;